/** Maps an object type to its query-param representation, where every value becomes an optional string. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type QueryParamsOf<T extends Record<string, any>> = { [key in keyof Partial<T>]: string | undefined };
